import React, { ReactElement } from 'react';
import { RouteComponentProps, StaticContext } from 'react-router';
import Markdown from 'react-markdown';
import path from 'path';
import NotFound from '../pages/NotFound';

import axios from '../const/axios';

import { ArticleData } from '../interfaces';
import styles from '../assets/styles/article.module.css';

export default class Article extends React.Component<{
	window: RouteComponentProps<any, StaticContext, any>
	articles: {
		[key: string]: ArticleData
	}
}, {
	data: string
}> {

	public state = {
		data: ''
	}

	getArticle(): void {
		try {
			let value = this.props.articles[window.location.pathname];
			if (!value) return;
			axios(`/articles/${this.props.window.match.params.section}/${value.id}.md?token=${Math.random().toString(32).slice(2)}`)
				.then(({data}) => {
					this.setState({ data });
				});
		} catch (e) {
			console.error(e);
		}
	}

	componentDidUpdate(): void {
		if (this.state.data) return;
		this.getArticle();
	}

	componentDidMount(): void {
		if (this.state.data) return;
		this.getArticle();
	}

	render(): ReactElement {
		let metadata = this.props.articles[window.location.pathname];
		if (!metadata) return <NotFound />;
		let body = this.state.data.trim();
		if (body.endsWith('.')) body = body + ' ∎';
		return (
			<div className={styles.article}>
				<h2>{<Markdown source={metadata.name} />}</h2>
				<h3>{<Markdown source={metadata.subtitle} />}</h3>
				<h3>{metadata.dateCreated}</h3>
				{body ? <Markdown
					source={body}
					transformLinkUri={(uri: string): string => {
						uri = Markdown.uriTransformer(uri);
						if (uri.startsWith('/') || uri.startsWith('./')) uri = path.join(process.env.PUBLIC_URL, uri);
						return uri;
					}}
				/> : null}
			</div>
		)
	}
}